export const CONTACT_FORM_ERRORS = 'CONTACT_FORM_ERRORS';
export const UPDATE_CONTACT_INFO = 'UPDATE_CONTACT_INFO';

export const CLICK_CONTACT_SUBMIT_BUTTON = 'CLICK_CONTACT_SUBMIT_BUTTON';
